import { Component, OnInit, Input, Output, EventEmitter, HostListener } from "@angular/core";
import { LogmanagementService } from "./logmanagement.service";
import { DomSanitizer } from "@angular/platform-browser";
import { ToastMessageService } from 'src/app/toastr.service';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment.prod';


@Component({
  selector: "app-logmanagement",
  templateUrl: "./logmanagement.component.html",
  styleUrls: ["./logmanagement.component.scss"],
})
export class LogmanagementComponent implements OnInit {
  LogData: any;
  first: number = 0;
  rows: number = 50;
  currentPage: number = 1;
  filteredLogData: any[] = [];
  searchValue: any;
  totalRecords: number = 0;
  oldDataVisible: boolean = false;
  newDataVisible: boolean = false;
  dropdownOptions: any[];
  selectedValue: string;
  selectedSource: string;
  selectedROA: string;
  selectedDsField: string;
  dropdownOptionsRC: any;
  // dsfielddropdownOptions: any[];
  sourceDropdownOptions: any[];
  totalPages: number = 0;
  firstArrayHeadings = [];
  secondArrayHeadings = [];
  firstArrayValues: any;
  secondArrayValues: any;
  SufirstArrayHeadings = [];
  SusecondArrayHeadings = [];
  compareArrayHeadings: any;
  compareArrayValues: any;
  SufirstArrayValues: any;
  SusecondArrayValues: any;

  //LMS Business Case
  LMSfirstArrayHeadings = [];
  LMSsecondArrayHeadings = [];
  LMSfirstArrayValues: any;
  LMSsecondArrayValues: any;

  uniqnumber: any;
  DsAndaDr: any;
  UserIp: any;
  email: any;
  oldheaders: any;
  oldArrayValues: any;
  impactFieldsData: any;
  costingFieldHeaders: any;
  costingFieldArrayValues: any;
  costingFieldData: any;
  businessCaseData: any;
  businessFieldHeaders: any;
  businessFieldArrayValues: any;
  sectionDropdownOptions: any;
  selectedSection: any;
  dbFieldDropdownOptions: any;
  dsFieldDropdownOptions: any;
  selectedField: any;
  fieldOptionsBySection: any;
  LmsDsTime: any;
  isDsTimeDialogVisible: boolean = false;
  isLoading: boolean = false;
  isApproving: boolean = false;
  isRejecting: boolean = false;
  isRechecking: boolean = false;
  isBlaProcessing: boolean = false;
  startdate: Date | undefined;
  enddate: Date | undefined;
  // startdate: Date[] = [];
  // enddate: Date[] = [];
  fieldOptionsBySectionDS: any;
  startDate: any;
  endDate: any;
  showScrapingServerDown: boolean = false;
  dateCleared: boolean = false;
  isError: boolean = false;
  errorMessage: string = '';
  fieldOptionsBySectionEL: any;
  // fieldToDisplay: string[] = [];
  isVisible: boolean = false
  ROADropdownOptions: any;
  loader: boolean = false;
  debounceTimer: any;
  LMSNotes: any;
  isDsNotesDialogVisible: any;
  formattedNotes: { type: string; details: string[] }[] = [];
  selectedRowIndex: number | null = null;
  isLiveOptions = [
    { label: 'Select Live or Not Live status', value: '', visible: true },
    { label: 'Product in Live', value: 'is_live', visible: true },
    { label: 'Product Not in Live', value: 'not_in_live', visible: true }

  ];
  selectedIsLive: string = '';
  showImpactFieldsDialog(item: any) {
    this.closeAllModals();
    item.impact_fields_visible = true;
  }

  showCostingFieldsDialog(item: any) {
    this.closeAllModals();
    item.costing_data_visible = true;
  }

  showBusinessCaseDialog(item: any) {
    this.closeAllModals();
    item.business_case_visible = true;
  }

  showDsTimeDialog() {
    this.closeAllModals();
    this.isDsTimeDialogVisible = true;
  }

  showDsNotesDialog() {
    this.closeAllModals();
    this.isDsNotesDialogVisible = true;
  }

  showOldDataDialog(item: any) {
    this.closeAllModals();
    item.old_data_visible = true;
    item.new_data_visible = false;
  }

  showNewDataDialog(item: any) {
    this.closeAllModals();
    item.new_data_visible = true;
    item.old_data_visible = false;
  }

  showErrorDialog(item: any): void {
    item.error_visible = true;
  }

  closeAllModals() {
    for (const item of this.LogData) {
      item.old_data_visible = false;
      item.new_data_visible = false;
      item.impact_fields_visible = false;
      item.costing_data_visible = false;
      item.business_case_visible = false;
      this.isDsTimeDialogVisible = false;
    }
  }

  private sectionDropdownOptionsAll: any[] = [];
  private fieldOptionsBySectionAll: any = {};
  private sectionDropdownOptionsPerm: any[] = [];
  private fieldOptionsBySectionPerm: any = {};

  private hasAllSectionsAccess: boolean = false;

  constructor(private cdRef: ChangeDetectorRef, private toastService: ToastMessageService, private logmanagementservice: LogmanagementService,
    private sanitized: DomSanitizer) { }

  ngOnInit(): void {

    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.selectedROA = "ALL";
    this.dropdownOptionsRC = [
      { label: 'PENDING', value: 'PENDING' },
      { label: 'RECHECK LIST', value: 'Recheck List' },
      { label: 'APPROVED', value: 'APPROVED' },
      { label: 'REJECT', value: 'REJECT' },
    ];

    this.dropdownOptions = [
      { label: 'PENDING', value: 'PENDING' },
      { label: 'APPROVED', value: 'APPROVED' },
      { label: 'REJECT', value: 'REJECT' }
    ];

    this.selectedValue = 'PENDING';

    this.sourceDropdownOptions = [
      { label: 'Select Source', value: 'Select Source', visible: true },
      { label: 'DB [DataBase]', value: 'DB' },
      { label: 'DS [Daily Script]', value: 'DS' },
      { label: 'SU [Script Update]', value: 'SU' },
      { label: 'EX-DB [Excel Dashboard]', value: 'EX-DB' },
      { label: 'MS [Monthly Script]', value: 'MS' },
      { label: 'EL [Litigation Dashboard]', value: 'EL' },
      { label: 'RC [FDA Label Recheck]', value: 'RC' },
      { label: 'EX-DB-IM [Excel Impact Fields]', value: 'EX-DB-IM' },
      { label: 'Business Case', value: 'Business Case' },
      { label: 'Edited Litigation Records', value: 'ELR' },
      { label: 'CL-AI', value: 'CL-AI' },
      { label: 'SP [Shortage Panel]', value: 'SP' },
    ];



    const lmsAccessRaw = localStorage.getItem('lms_access');
    console.log('Local Storage LMS Access:', lmsAccessRaw);

    const lmsAccess = JSON.parse(lmsAccessRaw || '{}');
    console.log('Parsed LMS Access:', lmsAccess);

    this.sourceDropdownOptions = this.sourceDropdownOptions.filter(option => {
      const accessKey = `LMS ${option.value}`;
      console.log("lms access", accessKey)
      const isVisible = accessKey === 'LMS Select Source' || lmsAccess[accessKey] === true;
      console.log(`Checking visibility for ${accessKey}: ${isVisible}`);
      return isVisible;
    });

    this.selectedSource = 'Select Source';

    this.sectionDropdownOptions = [
      { label: 'ALL', value: 'ALL' },
      { label: 'New NDA and New Dosage Form', value: 'All Sections' },
      { label: 'INNOVATOR/BRAND PRODUCT DETAILS', value: 'INNOVATOR/BRAND PRODUCT DETAILS' },
      { label: 'PATENT INFORMATION', value: 'PATENT INFORMATION' },
      { label: 'REGULATORY INFORMATION', value: 'REGULATORY INFORMATION' },
      { label: 'CLINICAL INFORMATION', value: 'CLINICAL INFORMATION' },
      { label: 'API INFORMATION', value: 'API INFORMATION' },
      { label: 'FORMULATION INFORMATION', value: 'FORMULATION INFORMATION' },
      { label: 'COMPETITIVE INTELLIGENCE', value: 'COMPETITIVE INTELLIGENCE' },
      { label: 'EXECUTIVE SUMMARY', value: 'EXECUTIVE SUMMARY' },
      { label: 'COSTING RELATED AND DETAILS', value: 'COSTING RELATED AND DETAILS' },
    ];

    const sectionsAccessRaw = localStorage.getItem('lms_sections_access');
    console.log('Local Storage LMS Access:', sectionsAccessRaw);

    const sectionAccess = JSON.parse(sectionsAccessRaw || '{}');
    console.log('Parsed Section Access:', sectionAccess);

    // Check if all sections have true access
    const sectionAllTrue = Object.values(sectionAccess).every((value) => value === true);
    console.log('Section All Fields True:', sectionAllTrue);
    this.hasAllSectionsAccess = sectionAllTrue;

    const sectionDropdownOptionsAll = [...this.sectionDropdownOptions];

    // Filter dropdown options based on access
    this.sectionDropdownOptions = this.sectionDropdownOptions.filter(option => {
      const sectionAccessKey = `${option.value}`;
      console.log("Checking LMS Access for:", sectionAccessKey);

      // Determine visibility
      const isVisible = sectionAccess[sectionAccessKey] === true;
      console.log(`Visibility for ${sectionAccessKey}: ${isVisible}`);

      return isVisible;
    });

    // // If all sections are true, add the 'ALL' option to the dropdown
    if (sectionAllTrue) {
      this.sectionDropdownOptions.unshift({ label: 'ALL', value: 'ALL' }, { label: 'New NDA and New Dosage Form', value: 'All Sections' });
      console.log("All sections have access. Showing 'ALL' option.");
    }

    // Set the selected section to 'ALL' if all sections are true, otherwise set to the first true section
    if (sectionAllTrue) {
      console.log("Setting selectedSection to 'ALL' in section");
      this.selectedSection = 'ALL';
    } else {
      // Set to the first section with a true value
      const firstTrueSection = Object.keys(sectionAccess).find(
        (section) => sectionAccess[section] === true
      );
      console.log("Setting selectedSection to:", firstTrueSection || 'ALL');
      this.selectedSection = firstTrueSection || 'ALL';  // Default to 'ALL' if no true section is found
    }

    console.log('Selected Section:', this.selectedSection);

    this.fieldOptionsBySectionDS = {
      'ALL': [
        { label: 'ALL', value: 'ALL' }
      ],
      'All Sections': [
        { label: 'ALL', value: 'ALL' },
        { label: 'NDA approval', value: 'NDA approval' },
        { label: 'New dosage form & new formulation', value: 'New dosage form & new formulation' },
      ],
      'INNOVATOR/BRAND PRODUCT DETAILS': [
        { label: 'ALL', value: 'ALL' },
        { label: 'FDA label', value: 'FDA label' },
      ],
      'PATENT INFORMATION': [
        { label: 'ALL', value: 'ALL' },
        { label: 'IPR details (if any)', value: 'IPR details (if any)' },
        { label: 'Delisted patents', value: 'Delisted patents' },
        { label: 'Newly added Patents', value: 'Newly added Patents' },
      ],
      'REGULATORY INFORMATION': [
        { label: 'ALL', value: 'ALL' },
        { label: 'FDA product specific BE guidance', value: 'FDA product specific BE guidance' },
      ],
      'CLINICAL INFORMATION': [
        { label: 'No Data', value: 'No Data' },
      ],
      'API INFORMATION': [
        { label: 'No Data', value: 'No Data' },
      ],
      'FORMULATION INFORMATION': [
        { label: 'No Data', value: 'No Data' },
      ],
      'COMPETITIVE INTELLIGENCE': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Approved ANDA filers', value: 'Approved ANDA filers' },
        { label: 'Tentatively approved ANDAs', value: 'Tentatively approved ANDAs' },
      ],
      'EXECUTIVE SUMMARY': [
        { label: 'No Data', value: 'No Data' },
      ],
      'COSTING RELATED AND DETAILS': [
        { label: 'No Data', value: 'No Data' },
      ],
    };

    this.fieldOptionsBySection = {
      'ALL': [
        { label: 'ALL', value: 'ALL' }
      ],
      'All Sections': [
        { label: 'No Data', value: 'No Data' }
      ],
      'INNOVATOR/BRAND PRODUCT DETAILS': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Brand Name/Proprietary Name', value: 'Brand Name/Proprietary Name' },
        { label: 'Active Ingredient', value: 'Active Ingredient' },
        { label: 'Strengths (mg)', value: 'Strengths (mg)' },
        { label: 'Route of Administration', value: 'Route of Administration' },
        { label: 'Dosage forms', value: 'Dosage forms' },
        { label: 'Nature of Dosage form', value: 'Nature of Dosage form' },
        { label: 'NDA number', value: 'NDA number' },
        { label: 'Submission Classification', value: 'Submission Classification' },
        { label: 'Approval date / Action date (mm-dd-yyyy)', value: 'Approval date / Action date (mm-dd-yyyy)' },
        { label: 'Innovator / Applicant Holder', value: 'Innovator / Applicant Holder' },
        { label: 'Marketing Status', value: 'Marketing Status' },
        { label: 'Dosage and Administration', value: 'Dosage and Administration' },
        { label: 'Indications and Usage', value: 'Indications and Usage' },
        { label: 'Recommended dose', value: 'Recommended dose' },
        { label: 'FDA label', value: 'FDA label' },
        { label: 'Approved in other geographies', value: 'Approved in other geographies' },
        { label: 'Oneclick Marketing Status', value: 'Oneclick Marketing Status' },
        { label: 'StrengthActiveAPIFillVolume', value: 'StrengthActiveAPIFillVolume' },
      ],
      'PATENT INFORMATION': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Orange Book patents', value: 'Orange Book patents' },
        { label: 'Additional patents', value: 'Additional patents' },
        { label: 'Exclusivity details', value: 'Exclusivity details' },
        { label: 'PDE applied 6 months*', value: 'PDE applied 6 months*' },
        { label: 'PTE applied (Max 5 years)', value: 'PTE applied (Max 5 years)' },
        { label: 'IPR details (if any)', value: 'IPR details (if any)' },
        { label: 'Anticipated Market Formation Date', value: 'Anticipated Market Formation Date' },
        { label: '505 B(2) Opportunity', value: '505 B(2) Opportunity' },
        { label: 'Additional comments on patents', value: 'Additional comments on patents' },
        { label: 'Delisted patents', value: 'Delisted patents' },
        { label: 'Type of Filing', value: 'Type of Filing' },
        { label: 'Newly added Patents', value: 'Newly added Patents' },
      ],
      'REGULATORY INFORMATION': [
        { label: 'ALL', value: 'ALL' },
        { label: 'NCE-1 date (dd-mm-yyyy)', value: 'NCE-1 date (dd-mm-yyyy)' },
        { label: 'Reference Listed Drug (RLD)', value: 'Reference Listed Drug (RLD)' },
        { label: 'Reference Standard (RS)', value: 'Reference Standard (RS)' },
        { label: 'Orphan Drug Exclusivity', value: 'Orphan Drug Exclusivity' },
        { label: 'FDA product specific BE guidance', value: 'FDA product specific BE guidance' },
        { label: 'Eligible for CGT exclusivity*', value: 'Eligible for CGT exclusivity*' },
        { label: 'Type of BE study', value: 'Type of BE study' },
        { label: 'Additional Comments on Regulatory Information', value: 'Additional Comments on Regulatory Information' },
        { label: 'Petitions filed', value: 'Petitions filed' },
        { label: 'Possibility of Petition', value: 'Possibility of Petition' },

      ],
      'CLINICAL INFORMATION': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Indications under clinical investigation / Condition', value: 'Indications under clinical investigation / Condition' },
        { label: 'Therapeutic class / AHFS Codes', value: 'Therapeutic class / AHFS Codes' },
        { label: 'ATC codes / Class', value: 'ATC codes / Class' },
        { label: 'Therapeutic Category', value: 'Therapeutic Category' },
        { label: 'REMS', value: 'REMS' },
        { label: 'Black-Box Warning', value: 'Black-Box Warning' },
        { label: 'Half-life (hrs)', value: 'Half-life (hrs)' },
        { label: 'Pharmacology', value: 'Pharmacology' },
        { label: 'Variability (% ISCV)', value: 'Variability (% ISCV)' },
        { label: 'PK Linearity', value: 'PK Linearity' },
        { label: 'Food effect', value: 'Food effect' },
        { label: 'No of analytes', value: 'No of analytes' },
        { label: 'Other studies (if any)', value: 'Other studies (if any)' },
        { label: 'Additional Comments on Clinical Info', value: 'Additional Comments on Clinical Info' },
        { label: 'No of Pilot Studies', value: 'No of Pilot Studies' },
        { label: 'Per subject cost(One analyte)', value: 'Per subject cost(One analyte)' },
        { label: 'Per subject cost(Two analyte)', value: 'Per subject cost(Two analyte)' },
        { label: 'PKPD type studies', value: 'PKPD type studies' },
        { label: 'Lifecycle Management', value: 'Lifecycle Management' },
        { label: 'Patient Population', value: 'Patient Population' }
      ],
      'API INFORMATION': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Generic Name of API', value: 'Generic Name of API' },
        { label: 'BCS class', value: 'BCS class' },
        { label: 'Potential API suppliers list', value: 'Potential API suppliers list' },
        { label: 'Existing DMF filers', value: 'Existing DMF filers' },
        { label: 'API Availibility', value: 'API Availibility' },
        { label: 'Additional Info on API availibility', value: 'Additional Info on API availibility' },
      ],
      'FORMULATION INFORMATION': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Qualitative composition (Q1)', value: 'Qualitative composition (Q1)' },
        { label: 'Quantitative composition (Q2)', value: 'Quantitative composition (Q2)' },
        { label: 'Shelf Life', value: 'Shelf Life' },
        { label: 'Pack Type', value: 'Pack Type' },
        { label: 'No of units per Pack', value: 'No of units per Pack' },
        { label: 'Single dose / Multiple dose', value: 'Single dose / Multiple dose' },
        { label: 'Additional comments on Formulation', value: 'Additional comments on Formulation' },
      ],
      'COMPETITIVE INTELLIGENCE': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Approved ANDA filers', value: 'Approved ANDA filers' },
        { label: 'Tentatively approved ANDAs', value: 'Tentatively approved ANDAs' },
        { label: 'Filed ANDA', value: 'Filed ANDA' },
        { label: 'Expected ANDA Entrants', value: 'Expected ANDA Entrants' },
        { label: 'No of shared FTFs', value: 'No of shared FTFs' },
        { label: 'Innovator / RLD Price ($/pack)', value: 'Innovator / RLD Price ($/pack)' },
        { label: 'Indicative API price ($/kg)', value: 'Indicative API price ($/kg)' },
        { label: 'Competing products', value: 'Competing products' },
        { label: 'Reported sales', value: 'Reported sales' },
        { label: 'Reported volume', value: 'Reported volume' },
        { label: 'Peak Sale Insights', value: 'Peak Sale Insights' },
        { label: 'Drug in Shortage currently?', value: 'Drug in Shortage currently?' },
        { label: 'Additional comments on Competitive Intelligence', value: 'Additional comments on Competitive Intelligence' },
        { label: '180 Day Exclusivity', value: '180 Day Exclusivity' },
        { label: 'Current Market Shares(%)', value: 'Current Market Shares(%)' },
        { label: 'Probable API source?', value: 'Probable API source?' },
        { label: 'Comment (if any)', value: 'Comment (if any)' },

        { label: 'Total api consumption in kg', value: 'Total api consumption in kg' },

      ],
      'EXECUTIVE SUMMARY': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Genericized', value: 'Genericized' },
        { label: 'Launch on approval?', value: 'Launch on approval?' },
        { label: 'First to file?', value: 'First to file?' },
        { label: 'First to launch?', value: 'First to launch?' },
        { label: 'Complexity', value: 'Complexity' },
        { label: 'Cumulative Investment($ Mn)', value: 'Cumulative Investment($ Mn)' },
        { label: 'Cumulative revenue projection($ Mn)', value: 'Cumulative revenue projection($ Mn)' },
        { label: 'Peak annual sales(Mn $)', value: 'Peak annual sales(Mn $)' },
        { label: 'IRR( %)', value: 'IRR( %)' },
        { label: 'Gross Profit', value: 'Gross Profit' },
        { label: 'Earliest Filing possibility', value: 'Earliest Filing possibility' },
        { label: 'Competition', value: 'Competition' },
      ],
      'COSTING RELATED AND DETAILS': [
        { label: 'ALL', value: 'ALL' },
        { label: 'New Possible Strengths', value: 'New Possible Strengths' },
        { label: 'Stability', value: 'Stability' },
        { label: 'BE / Regulatory', value: 'BE / Regulatory' },
        { label: 'Process', value: 'Process' },
        { label: 'Extensive Characterization', value: 'Extensive Characterization' },
        { label: 'Dev Challenge', value: 'Dev Challenge' },
        { label: 'IP Strategy', value: 'IP Strategy' },
        { label: 'No of Patents Challenged', value: 'No of Patents Challenged' },
        { label: 'Strength / API Content', value: 'Strength / API Content' },
        { label: 'Packaging', value: 'Packaging' },
        { label: 'Technology', value: 'Technology' },
        { label: 'Priority review for ANDA possible?', value: 'Priority review for ANDA possible?' },
        { label: 'Unverified activities (API supply)', value: 'Unverified activities (API supply)' },
        { label: 'Fermantation product? (Yes / No)', value: 'Fermantation product? (Yes / No)' },
      ],
    };

    const fieldOptionsBySectionAll = JSON.parse(JSON.stringify(this.fieldOptionsBySection));


    // const sectionsAccess = JSON.parse(sectionsAccessRaw || '{}');
    // // console.log('Parsed Section Access:', sectionsAccess);

    // const DBfieldsAccessRaw = localStorage.getItem('lms_field_access');
    // // console.log('Local Storage LMS Field Access:', DBfieldsAccessRaw);

    // const DBfieldsAccess = JSON.parse(DBfieldsAccessRaw || '{}');
    // // console.log('Parsed Field Access:', DBfieldsAccess);

    // this.fieldOptionsBySection = Object.keys(this.fieldOptionsBySection).reduce((acc, sectionName) => {
    //   const isSectionAccessible = sectionsAccess[sectionName] === true;

    //   if (isSectionAccessible) {
    //     const filteredFields = this.fieldOptionsBySection[sectionName].filter(field => {
    //       const fieldAccessKey = field.value;
    //       const isFieldAccessible = DBfieldsAccess[fieldAccessKey] === true;
    //       return isFieldAccessible;
    //     });
    //     console.log("filteredFields", filteredFields)

    //     if (filteredFields.length > 0) {
    //       acc[sectionName] = filteredFields;
    //     }
    //   }

    //   return acc;
    // }, {});

    const sectionsAccess = JSON.parse(sectionsAccessRaw || '{}');
    // console.log('Parsed Section Access:', sectionsAccess);

    const DBfieldsAccessRaw = localStorage.getItem('lms_field_access');
    // console.log('Local Storage LMS Field Access:', DBfieldsAccessRaw);

    const DBfieldsAccess = JSON.parse(DBfieldsAccessRaw || '{}');
    // console.log('Parsed Field Access:', DBfieldsAccess);

    this.fieldOptionsBySection = Object.keys(this.fieldOptionsBySection).reduce((acc, sectionName) => {
      const isSectionAccessible = sectionsAccess[sectionName] === true ||
        ((sectionName === 'ALL' || sectionName === 'All Sections') && sectionAllTrue);


      if (isSectionAccessible) {
        const fields = this.fieldOptionsBySection[sectionName];

        // Filter out the 'ALL' option for comparison
        const fieldsWithoutAll = fields.filter(field => field.value !== 'ALL');

        const filteredFields = fieldsWithoutAll.filter(field => {
          const fieldAccessKey = field.value;
          return DBfieldsAccess[fieldAccessKey] === true;
        });
        console.log("filteredFields", filteredFields);
        console.log("filteredFieldslength", filteredFields.length);
        console.log("fieldsWithoutAllLength", fieldsWithoutAll.length);

        if (filteredFields.length > 0) {
          // Check if all fields are accessible
          const allFieldsAccessible = filteredFields.length === fieldsWithoutAll.length;
          console.log("allFieldsAccessible", allFieldsAccessible);

          const forceAllForSourceInInit = (this.selectedSource === 'EX-DB' || this.selectedSource === 'EX-DB-IM');

          if (allFieldsAccessible || forceAllForSourceInInit) {
            // Set 'ALL' as the selectedField for the section
            acc[sectionName] = [{ label: 'ALL', value: 'ALL' }, ...filteredFields];
          } else {
            acc[sectionName] = filteredFields;
          }
        }
      }

      return acc;
    }, {});

    this.sectionDropdownOptionsPerm = [...this.sectionDropdownOptions];
    this.fieldOptionsBySectionPerm = JSON.parse(JSON.stringify(this.fieldOptionsBySection));

    this.fieldOptionsBySectionEL = {
      'ALL': [
        { label: 'ALL', value: 'ALL' }
      ],
      'COMPETITIVE INTELLIGENCE': [
        { label: 'ALL', value: 'ALL' },
        { label: 'Filed ANDA', value: 'Filed ANDA' }
      ]
    };

    // this.selectedField = "ALL"
    const DBlocalfieldsAccessRaw = localStorage.getItem('lms_field_access');
    const DBlocalfieldsAccess = JSON.parse(DBlocalfieldsAccessRaw || '{}');
    const allFieldsTruee = Object.values(DBlocalfieldsAccess).every((value) => value === true);
    console.log('All Fields True:', allFieldsTruee);

    // If all fields are true, set selectedField to 'ALL'
    if (allFieldsTruee) {
      this.selectedField = 'ALL';
    } else {
      const firstTrueField = Object.keys(DBlocalfieldsAccess).find(
        (field) => DBlocalfieldsAccess[field] === true
      );
      console.log("knviofnbojfnbkik")
      this.selectedField = firstTrueField || 'ALL';  // Default to 'ALL' if no true field is found
    }
    console.log("Selected Field", this.selectedField)
    this.searchMolecule1();
    this.getLmsDsTime();
    this.getRoa();
    this.LmsNotes();

    this.sectionDropdownOptionsAll = sectionDropdownOptionsAll;
    this.fieldOptionsBySectionAll = fieldOptionsBySectionAll;

  }

  onDropdownChange(type: 'source' | 'value' | 'roa' | 'section' | 'field' | 'is_live') {
    this.currentPage = 1;
    if (type === 'source' || type === 'section') {
      this.selectedROA = "ALL";
    }

    // ============================
    // ✅ 1) HANDLE SOURCE CHANGE FIRST
    // ============================
    if (type === 'source') {

      // ✅ if user selected EX-DB / EX-DB-IM => show ALL sections + ALL fields
      if (this.isExcelSources()) {
        this.sectionDropdownOptions = [...this.sectionDropdownOptionsAll];
        this.selectedSection = 'ALL';

        this.dbFieldDropdownOptions =
          this.fieldOptionsBySectionAll['ALL'] || [{ label: 'ALL', value: 'ALL' }];

        this.selectedField = 'ALL';

        this.cdRef.detectChanges();
        this.searchMolecule1();
        return;
      }

      // ✅ restore permission based options (non-excel sources)
      this.sectionDropdownOptions = [...this.sectionDropdownOptionsPerm];

      // keep your existing rule: remove ALL if not allowed
      if (!this.hasAllSectionsAccess) {
        this.sectionDropdownOptions = this.sectionDropdownOptions.filter(x => x.value !== 'ALL');
      }

      this.selectedSection = this.sectionDropdownOptions?.[0]?.value || 'ALL';

      if (this.selectedSource === 'DS') {
        this.setDefaultDsField();   // ✅ DS fields
      } else if (this.selectedSource === 'SP') {
        this.selectedSection = 'SHORTAGE';
        this.selectedField = 'NDA_MAPPING';
      } else {
        const rawOptions = this.fieldOptionsBySectionPerm[this.selectedSection] || [];
        this.dbFieldDropdownOptions = this.injectOrangeBookPatentUseCode(rawOptions);
        this.selectedField = this.dbFieldDropdownOptions?.[0]?.value || 'ALL';
      }

      this.cdRef.detectChanges();
      this.searchMolecule1();
      return;
    }

    // ============================
    // ✅ 2) HANDLE SECTION CHANGE
    // ============================
    if (type === 'section') {

      // ✅ EX-DB always forces ALL field
      if (this.isExcelSources()) {
        this.dbFieldDropdownOptions =
          this.fieldOptionsBySectionAll[this.selectedSection] || [{ label: 'ALL', value: 'ALL' }];
        this.selectedField = 'ALL';

        this.cdRef.detectChanges();
        this.searchMolecule1();
        return;
      }

      // ✅ your existing non-excel logic
      if (this.selectedSource === 'DB') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySection[this.selectedSection] || [];
      } else if (this.selectedSource === 'DS') {
        this.setDefaultDsField();

        this.cdRef.detectChanges();
        this.searchMolecule1();
        return;
        // this.dsFieldDropdownOptions = this.fieldOptionsBySectionDS[this.selectedSection] || [];
      } else if (this.selectedSource === 'SU') {
        this.dbFieldDropdownOptions = this.injectOrangeBookPatentUseCode(this.fieldOptionsBySection[this.selectedSection] || []);
      } else if (this.selectedSource === 'MS') {
        this.dbFieldDropdownOptions = this.injectOrangeBookPatentUseCode(this.fieldOptionsBySection[this.selectedSection] || []);
      } else if (this.selectedSource === 'EL') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySectionEL[this.selectedSection] || [];
      } else if (this.selectedSource === 'RC') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySection[this.selectedSection] || [];
      } else if (this.selectedSource === 'EX-DB-IM') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySection[this.selectedSection] || [];
      } else if (this.selectedSource === 'EX-DB') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySection[this.selectedSection] || [];
      } else if (this.selectedSource === 'CL-AI') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySection[this.selectedSection] || [];
      } else if (this.selectedSource === 'Business Case') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySection[this.selectedSection] || [];
      } else if (this.selectedSource === 'ELR') {
        this.dbFieldDropdownOptions = this.fieldOptionsBySection[this.selectedSection] || [];
      }

      if (this.selectedSource !== 'DS') {
        const sectionDBfieldsAccessRaw = localStorage.getItem('lms_field_access');
        const sectionDBfieldsAccess = JSON.parse(sectionDBfieldsAccessRaw || '{}');
        const sectionAllFieldsTrue = Object.values(sectionDBfieldsAccess).every(v => v === true);

        if (sectionAllFieldsTrue) {
          this.selectedField = 'ALL';
        } else {
          const firstTrueFieldInSection = Object.keys(sectionDBfieldsAccess).find(
            (field) => sectionDBfieldsAccess[field] === true
          );
          this.selectedField = firstTrueFieldInSection || 'ALL';
        }
      }
    }

    // ============================
    // ✅ 3) FOR OTHER FILTER CHANGES
    // ============================
    if (this.isExcelSources()) {
      // keep existing behavior: excel sources always ALL field
      this.selectedField = 'ALL';
    }

    this.searchMolecule1();
  }



  searchMolecule1() {
    this.loader = true;
    this.first = (this.currentPage - 1) * this.rows;
    const roaFilter = this.selectedROA;
    if (this.dateCleared) {
      this.startDate = undefined;
      this.endDate = undefined;
    }

    if (this.selectedSource === 'SP') {
      this.logmanagementservice.getShortageStatusLogData(this.currentPage, this.rows, this.searchValue, this.selectedValue, this.startDate, this.endDate, this.email).subscribe((response) => {
        this.LogData = response["data"];
        if (this.LogData != null) {
          this.filteredLogData = [...this.LogData];
        }
        this.totalRecords = response?.total_records || 0;
        this.loader = false;
      }, (error) => {
        console.error('Error fetching shortage status data', error);
        this.loader = false;
      });
    } else {
      this.logmanagementservice.getLogData(this.currentPage, this.rows, this.searchValue, this.selectedValue, this.selectedSource, roaFilter, this.selectedSection, this.selectedField, this.startDate, this.endDate, this.email, this.selectedIsLive).subscribe((response) => {
        this.LogData = response["data"];
        if (this.LogData != null) {
          this.filteredLogData = [...this.LogData];
          console.log("filter data", this.filteredLogData)
        }
        this.totalRecords = response?.total_records || 0;
        console.log('Total Records:', this.totalRecords);
        this.loader = false;
      },
        (error) => {
          console.error('Error fetching data', error);
          this.loader = false;  // Hide loader on error
        });
    }
    this.dateCleared = false;
  }

  // getRoa() {
  //   this.loader = true;
  //   this.logmanagementservice.getUniqueRoa().subscribe(
  //     (response) => {
  //       this.ROADropdownOptions = [{ label: 'ALL', value: 'ALL' }, ...response["data"].map(roa => ({ label: roa, value: roa }))];
  //       this.selectedROA = 'All';  // Set default selection to "All"
  //       this.loader = false;
  //     },
  //     (error) => {
  //       console.error('Error fetching data', error);
  //       this.loader = false;
  //     }
  //   );
  // }

  getRoa() {
    this.loader = true;
    this.logmanagementservice.getUniqueRoa().subscribe(
      (response) => {
        // Map response data to dropdown options without adding 'ALL'
        this.ROADropdownOptions = response["data"].map(roa => ({ label: roa, value: roa }));

        // Set selectedROA to null so the placeholder shows by default
        this.selectedROA = "ALL";

        this.loader = false;
      },
      (error) => {
        console.error('Error fetching data', error);
        this.loader = false;
      }
    );
  }

  // filterData() {
  //   if (this.searchValue) {
  //     this.filteredLogData = this.LogData.filter(item => {
  //       return item.brand_name && item.brand_name.toLowerCase().includes(this.searchValue.toLowerCase());
  //     });
  //   } else {
  //     this.filteredLogData = [...this.LogData];
  //   }

  //   this.totalRecords = this.filteredLogData.length;
  //   this.updatePaginator();
  // }
  filterData() {
    // Clear any existing timer to avoid multiple calls
    clearTimeout(this.debounceTimer);

    // Set a new timer that calls the search function after 300ms
    this.debounceTimer = setTimeout(() => {
      // Check if searchValue is empty or null, if so, pass a specific value to show all entries
      const searchQuery = this.searchValue.trim() === '' ? null : this.searchValue.trim();

      // Call the search function with the appropriate searchQuery
      console.log("this.selectedField", this.selectedField)
      this.searchMolecule1();
    }, 300);  // 300ms delay
  }

  onPageChange(event: any) {
    this.rows = event.rows;
    this.first = event.first;
    this.currentPage = event.page + 1;
    console.log("in onPageChange", this.currentPage);
    this.searchMolecule1();
  }

  updatePaginator() {
    this.first = 0;
  }

  // approveRecord(uniqNumber: string, UserIp, approve_reject_by, status: string) {
  //   this.logmanagementservice.getDSAndaDR(uniqNumber, this.UserIp, this.email, status).subscribe((response) => {
  //     this.DsAndaDr = response;
  //     console.log(this.DsAndaDr)
  //     // location.reload();
  //     // this.searchMolecule1();
  //   });
  // }

  ClAiNewData(newData: any, item?: any) {
    if (newData && newData[0]) {
      this.firstArrayHeadings = Object.keys(newData[0][0] || {});
      this.firstArrayValues = newData[0].map((obj: any) => Object.values(obj));
    }

    if (item && item.selected_option !== undefined && item.selected_option !== null) {
      item.selectedDataIndex = parseInt(item.selected_option, 10) - 1;
    }
  }

  isMultipleOptions(newData: any): boolean {
    if (!newData || !newData[1] || newData[1].length === 0) {
      return false;
    }
    return Array.isArray(newData[1][0]);
  }

  approveRecord(uniqNumber: string, UserIp: string, approve_reject_by: string, status: string, item?: any) {
    let selectedData = null;
    let selectedOption = null;

    if (item && item.source === 'CL-AI' && item.selectedDataIndex !== undefined && item.selectedDataIndex !== null) {
      selectedData = item.new_data[1][item.selectedDataIndex];
      selectedOption = (item.selectedDataIndex + 1).toString(); // Convert 0-based index to 1-based: 0 → "1", 1 → "2"
    }

    const isProcessing = status === 'approved' || status === 'rejected' || status === 'recheck' || status === 'bla';
    if (isProcessing) {
      if (status === 'approved') {
        this.isApproving = true;
      } else if (status === 'rejected') {
        this.isRejecting = true;
      } else if (status === 'recheck') {
        this.isRechecking = true;
      } else if (status === 'bla') {
        this.isBlaProcessing = true;
      }

      if (item && item.source === 'SP') {
        const statusActionMap = {
          'approved': 1,
          'rejected': 2,
          'bla': 3
        };

        const payload = {
          uniq_number: uniqNumber,
          action: statusActionMap[status],
          user_ip: UserIp,
          user_email: this.email
        };

        this.logmanagementservice.updateShortageStatus(payload).subscribe(
          (response) => {
            this.isLoading = false;
            this.searchMolecule1();
            if (response['message'] === 'LMS updated successfully') {
              this.toastService.success('Shortage record updated successfully!');
            } else {
              this.toastService.error('Failed to update shortage record!');
            }
            this.resetLoadingStates();
          },
          (error) => {
            this.isLoading = false;
            this.resetLoadingStates();
            this.toastService.error('Failed to update shortage record!');
          }
        );
      } else {
        this.logmanagementservice.getDSAndaDR(uniqNumber, UserIp, this.email, status, selectedOption).subscribe(
          (response) => {
            this.DsAndaDr = response;
            this.isLoading = false;
            console.log(this.DsAndaDr);
            this.searchMolecule1();

            if (status === 'approved' && response['message'] === 'Approved data successfully') {
              this.toastService.success('Data approved successfully!');
            } else if (status === 'rejected' && response['message'] === 'Rejected data successfully') {
              this.toastService.success('Data rejected successfully!');
            } else if (status === 'recheck' && response['message'] === 'Successfully added data to the Recheck list.') {
              this.toastService.success('Data rechecked successfully!');
            } else {
              this.toastService.error('Failed to approve/reject record!');
            }

            this.resetLoadingStates();
          },
          (error) => {
            this.isLoading = false;
            this.resetLoadingStates();
            this.toastService.error('Failed to approve/reject record!');
          }
        );
      }
    }
  }

  private resetLoadingStates() {
    this.isApproving = false;
    this.isRejecting = false;
    this.isRechecking = false;
    this.isBlaProcessing = false;
  }

  LmsNotes() {
    this.logmanagementservice.getLMSNotes().subscribe((response) => {
      this.LMSNotes = response;

      // Convert response object to an array for easier looping in the template
      this.formattedNotes = Object.entries(this.LMSNotes).map(([key, value]) => ({
        type: key,
        details: value as string[] // Assuming `value` is always an array of strings
      }));

      console.log("Formatted Notes:", this.formattedNotes);
    });
  }

  onSelectRow(index: number): void {
    event.stopPropagation();
    this.selectedRowIndex = index; // Set the selected row index
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const tableElement = document.getElementById('myTable');
    if (tableElement && !tableElement.contains(event.target as Node)) {
      this.selectedRowIndex = null; // Clear the selection
    }
  }

  getLmsDsTime() {
    this.logmanagementservice.getDSTime().subscribe((response) => {
      this.LmsDsTime = response["data"];
      console.log("resss", this.LmsDsTime);
      this.showScrapingServerDown = false;
      const firstItem = this.LmsDsTime[0];
      const calculateTimeDifference = (field: string) => {
        const endTimeString = firstItem?.[field]?.end_time;
        // console.log("endTimeString", endTimeString);
        if (endTimeString) {
          const datePart = endTimeString.split(' ')[0];
          const [day, month, year] = datePart.split('-');
          const dayInt = parseInt(day);
          const monthInt = parseInt(month) - 1;
          const yearInt = parseInt(year);
          const endDate = new Date(yearInt, monthInt, dayInt);
          // console.log("endDate", endDate);

          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);

          const timeDifference = currentDate.getTime() - endDate.getTime();
          const daysDifference = timeDifference / (1000 * 3600 * 24);
          // console.log("daysDifference", daysDifference);

          if (daysDifference > 1 || (firstItem?.[field]?.message != 'Success' && firstItem?.[field]?.message != 'No new date found in new or revised be guidance.')) {
            // this.fieldToDisplay.push(field);
            // console.log("firstItem?.[field]?.message", firstItem?.[field]?.message);
            console.log(`${field} - More than 1 day difference`);
            this.showScrapingServerDown = true;
          }
        }
      };

      calculateTimeDifference('current_month_anda');
      calculateTimeDifference('past_month_anda');
      calculateTimeDifference('be_guidance');
      calculateTimeDifference('new_dosage_form_and_formulation');
      calculateTimeDifference('labling');
      calculateTimeDifference('New_Nda');
      calculateTimeDifference('delisted_patents');
      calculateTimeDifference('newly_added_patents');
      calculateTimeDifference('Strength');
      calculateTimeDifference('tentative_anda');
      // Add more fields here...

      //   const endTimeString = firstItem?.new_dosage_form_and_formulation?.end_time;
      //   console.log("endTimeString", endTimeString);
      //   const datePart = endTimeString.split(' ')[0];
      //   const [day, month, year] = datePart.split('-');

      //   const dayInt = parseInt(day);
      //   const monthInt = parseInt(month) - 1;
      //   const yearInt = parseInt(year);

      //   const endDate = new Date(yearInt, monthInt, dayInt);
      //   console.log("JavaScript Date object:", endDate);
      //   // const endDate = new Date("2024-03-27");
      //   const currentDate = new Date();
      //   currentDate.setHours(0, 0, 0, 0);
      //   // console.log("currentDate", currentDate);

      //   const timeDifference = currentDate.getTime() - endDate.getTime();
      //   console.log("timeDifference:", timeDifference);
      //   const daysDifference = timeDifference / (1000 * 3600 * 24);

      //   console.log("Days Difference:", daysDifference);
      //   if (daysDifference > 1) {
      //     console.log("Less than 1 day difference");
      //     this.showScrapingServerDown = true;
      //   }

      //   const endTimeStringnda = firstItem?.New_Nda?.end_time;
      //   // console.log("endTimeString", endTimeString);
      //   const datePartnda = endTimeStringnda.split(' ')[0];
      //   const [daynda, monthnda, yearnda] = datePartnda.split('-');

      //   const dayIntnda = parseInt(daynda);
      //   const monthIntnda = parseInt(monthnda) - 1;
      //   const yearIntnda = parseInt(yearnda);

      //   const endDatenda = new Date(yearIntnda, monthIntnda, dayIntnda);
      //   // console.log("JavaScript Date object:", endDate);

      //   const currentDatenda = new Date();
      //   currentDatenda.setHours(0, 0, 0, 0);
      //   // console.log("currentDate", currentDate);

      //   const timeDifferencenda = currentDatenda.getTime() - endDatenda.getTime();
      //   // console.log("timeDifference:", timeDifference);
      //   const daysDifferencenda = timeDifferencenda / (1000 * 3600 * 24);

      //   // console.log("Days Difference:", daysDifference);
      //   if (daysDifferencenda > 1) {
      //     console.log("Less than 1 day difference");
      //     this.showScrapingServerDown = true;
      //   }
    });
  }

  DsOldData(oldData) {
    if (oldData.length >= 1) {
      this.oldheaders = Object.keys(oldData[0]);
    }

    this.oldArrayValues = oldData.map((item: any) => {
      return this.oldheaders.map((key: string) => item[key]);
    });

    console.log("olddssdd", this.oldArrayValues);
  }

  LMSBusinessCaseOldData(oldData) {

  }
  MsOldData(oldData) {
    if (oldData.length >= 1) {
      this.oldheaders = Object.keys(oldData[0]);
    }

    this.oldArrayValues = oldData.map((item: any) => {
      return this.oldheaders.map((key: string) => item[key]);
    });

    // console.log("olddssdd", this.oldArrayValues);
  }

  DsNewData(newData) {
    if (newData.length >= 2) {
      this.firstArrayHeadings = Object.keys(newData[0][0]);
      this.secondArrayHeadings = Object.keys(newData[1][0]);
    }

    this.firstArrayValues = newData[0].map((item: any) => {
      return this.firstArrayHeadings.map((key: string) => item[key]);
    });

    this.secondArrayValues = newData[1].map((item: any) => {
      return this.secondArrayHeadings.map((key: string) => item[key]);
    });
    // console.log("neeww", this.firstArrayValues)
    // console.log("neww2", this.secondArrayValues)
  }

  RCNewData(newData) {
    if (newData.length >= 2) {
      this.firstArrayHeadings = Object.keys(newData[0][0]);
      this.secondArrayHeadings = Object.keys(newData[1][0]);
    }

    this.firstArrayValues = newData[0].map((item: any) => {
      return this.firstArrayHeadings.map((key: string) => item[key]);
    });

    this.secondArrayValues = newData[1].map((item: any) => {
      return this.secondArrayHeadings.map((key: string) => item[key]);
    });
    // console.log("neeww", this.firstArrayValues)
    // console.log("neww2", this.secondArrayValues)
  }

  SuNewData(newData) {
    if (newData.length >= 2) {
      this.SufirstArrayHeadings = Object.keys(newData[0][0]);
      this.SusecondArrayHeadings = Object.keys(newData[1][0]);
    }

    this.SufirstArrayValues = newData[0].map((item: any) => {
      return this.SufirstArrayHeadings.map((key: string) => item[key]);
    });

    this.SusecondArrayValues = newData[1].map((item: any) => {
      return this.SusecondArrayHeadings.map((key: string) => item[key]);
    });
    console.log("neeww", this.firstArrayValues)
    console.log("neww2", this.secondArrayValues)
  }


  LMSNewData(newData) {
    if (newData.length >= 2) {
      this.LMSfirstArrayHeadings = Object.keys(newData[0][0]);
      this.LMSsecondArrayHeadings = Object.keys(newData[1][0]);
    }

    this.LMSfirstArrayValues = newData[0].map((item: any) => {
      return this.LMSfirstArrayHeadings.map((key: string) => item[key]);
    });

    this.LMSsecondArrayValues = newData[1].map((item: any) => {
      return this.LMSsecondArrayHeadings.map((key: string) => item[key]);
    });
  }

  MsNewData(newData) {
    if (newData.length >= 2) {
      this.firstArrayHeadings = Object.keys(newData[0][0]);
      this.secondArrayHeadings = Object.keys(newData[1][0]);
    }

    this.firstArrayValues = newData[0].map((item: any) => {
      return this.firstArrayHeadings.map((key: string) => item[key]);
    });

    this.secondArrayValues = newData[1].map((item: any) => {
      return this.secondArrayHeadings.map((key: string) => item[key]);
    });
    // console.log("neeww", this.firstArrayValues)
    // console.log("neww2", this.secondArrayValues)
  }

  // MsNewData(compareData: any[]) {
  //   // Extract and process data based on the "data" field in compare_data
  //   this.compareArrayHeadings = compareData.length > 0 ? Object.keys(compareData[0].data) : [];
  //   this.compareArrayValues = compareData.map((item: any) => ({
  //     values: this.compareArrayHeadings.map((key: string) => item.data[key]),
  //     comment: item.comment,
  //   }));
  // }

  MsCompareData(newData: any) {
    if (newData.length >= 2) {
      // Extract headings from the first and second arrays
      this.firstArrayHeadings = Object.keys(newData[0][0]);
      this.secondArrayHeadings = Object.keys(newData[1][0].data); // Adjust to account for nested `data`
    }

    // Map values for the first array
    this.firstArrayValues = newData[0].map((item: any) => {
      return this.firstArrayHeadings.map((key: string) => item[key]);
    });

    // Map values for the second array, including the comment
    this.secondArrayValues = newData[1].map((item: any) => {
      const rowValues = this.secondArrayHeadings.map((key: string) => item.data[key] || ''); // Handle undefined keys gracefully
      return { rowValues, comment: item.comment };
    });
  }


  SuCompareData(newData: any) {
    if (newData.length >= 2) {
      // Extract headings from the first and second arrays
      this.firstArrayHeadings = Object.keys(newData[0][0]);
      this.secondArrayHeadings = Object.keys(newData[1][0].data); // Adjust to account for nested `data`
    }



    // Map values for the first array
    this.firstArrayValues = newData[0].map((item: any) => {
      return this.firstArrayHeadings.map((key: string) => item[key]);
    });

    // Map values for the second array, including the comment
    this.secondArrayValues = newData[1].map((item: any) => {
      const rowValues = this.secondArrayHeadings.map((key: string) => item.data[key] || ''); // Handle undefined keys gracefully
      return { rowValues, comment: item.comment };
    });
  }

  LMSCompareData(newData: any) {
    if (newData.length >= 2) {
      // Extract headings from the first and second arrays
      this.LMSfirstArrayHeadings = Object.keys(newData[0][0]);
      this.LMSsecondArrayHeadings = Object.keys(newData[1][0].data); // Adjust to account for nested `data`
    }



    // Map values for the first array
    this.LMSfirstArrayValues = newData[0].map((item: any) => {
      return this.LMSfirstArrayHeadings.map((key: string) => item[key]);
    });

    // Map values for the second array, including the comment
    this.LMSsecondArrayValues = newData[1].map((item: any) => {
      const rowValues = this.LMSsecondArrayHeadings.map((key: string) => item.data[key] || ''); // Handle undefined keys gracefully
      return { rowValues, comment: item.comment };
    });
  }

  exDbImCompareData(newData: any) {
    // if (newData.length >= 2) {
    //   // Extract headings from the first and second arrays
    //   this.firstArrayHeadings = Object.keys(newData[0][0]);
    //   this.secondArrayHeadings = Object.keys(newData?.[1]?.[0]); // Adjust to account for nested `data`

    //   this.secondArrayHeadings = Object.keys(newData?.[1]?.[0]).filter((key: string) => key !== 'update'); // Use the first item to get the keys

    //   this.secondArrayValues = newData?.[1]?.map((item: any) => {
    //     // For each item, create an array of values based on the keys
    //     const rowValues = this.secondArrayHeadings
    //       .filter((key: string) => key !== 'update') // Remove 'operation' from the headings
    //       .map((key: string) => item[key] || '');
    //     return { rowValues, comment: item.update }; // Use `operation` to determine the row color
    //   });

    // }

    // // Map values for the first array
    // this.firstArrayValues = newData[0].map((item: any) => {
    //   return this.firstArrayHeadings.map((key: string) => item[key]);
    // });

    // // Map values for the second array, including the comment

    // // Map values for the second array


    if (newData.length >= 2) {
      // Extract headings from the first and second arrays
      this.firstArrayHeadings = Object.keys(newData[0][0]);
      this.secondArrayHeadings = Object.keys(newData[1][0].data); // Adjust to account for nested `data`
    }

    // Map values for the first array
    this.firstArrayValues = newData[0].map((item: any) => {
      return this.firstArrayHeadings.map((key: string) => item[key]);
    });

    // Map values for the second array, including the comment
    this.secondArrayValues = newData[1].map((item: any) => {
      const rowValues = this.secondArrayHeadings.map((key: string) => item.data[key] || ''); // Handle undefined keys gracefully
      return { rowValues, comment: item.update };
    });

  }

  EXDBCompareData(newData: any) {
    // Extract headings from the response
    this.secondArrayHeadings = Object.keys(newData[0]).filter((key: string) => key !== 'operation' && key !== 'record_id'); // Use the first item to get the keys

    // Map values for the second array
    this.secondArrayValues = newData.map((item: any) => {
      // For each item, create an array of values based on the keys
      const rowValues = this.secondArrayHeadings
        .filter((key: string) => key !== 'operation' && key !== 'record_id') // Remove 'operation' from the headings
        .map((key: string) => item[key] || '');
      return { rowValues, operation: item.operation }; // Use `operation` to determine the row color
    });
  }

  ELRCompareData(newData: any) {
    // Extract headings from the response
    if (newData.length >= 2) {
      this.SufirstArrayHeadings = Object.keys(newData[0][0]);
      this.SusecondArrayHeadings = Object.keys(newData[1][0]);
    }

    this.SufirstArrayValues = newData[0].map((item: any) => {
      return this.SufirstArrayHeadings.map((key: string) => item[key]);
    });

    this.SusecondArrayValues = newData[1].map((item: any) => {
      return this.SusecondArrayHeadings.map((key: string) => item[key]);
    });
  }

  ELNewData(newData) {
    if (newData.length >= 2) {
      this.SufirstArrayHeadings = Object.keys(newData[0][0]);
      this.SusecondArrayHeadings = Object.keys(newData[1][0]);
    }

    this.SufirstArrayValues = newData[0].map((item: any) => {
      return this.SufirstArrayHeadings.map((key: string) => item[key]);
    });

    this.SusecondArrayValues = newData[1].map((item: any) => {
      return this.SusecondArrayHeadings.map((key: string) => item[key]);
    });
    // console.log("neeww", this.firstArrayValues)
    // console.log("neww2", this.secondArrayValues)
  }

  ImpactFieldsData(impactField) {
    this.impactFieldsData = impactField;
  }

  isArrayWithData(value: any): boolean {
    return Array.isArray(value) && value.length > 0 && typeof value[0] === 'object';
  }

  DsCostingFieldData(costingFieldData) {
    if (costingFieldData.length >= 1) {
      this.costingFieldHeaders = Object.keys(costingFieldData[0]);
    }

    this.costingFieldArrayValues = costingFieldData.map((item: any) => {
      return this.costingFieldHeaders.map((key: string) => item[key]);
    });
  }

  DsBusinessCaseData(businessCaseData) {
    if (businessCaseData.length >= 1) {
      this.businessFieldHeaders = Object.keys(businessCaseData[0]);
    }

    this.businessFieldArrayValues = businessCaseData.map((item: any) => {
      return this.businessFieldHeaders.map((key: string) => item[key]);
    });
  }

  openPdf(value) {
    let url: any = window.open(`${environment.ip}pm_backend/${value}`);
    // let url: any = window.open(`http://3.111.249.237/pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }

  onDateChange(event: any) {
    this.startDate = this.startdate.toLocaleDateString("es-CL");
    console.log(this.startDate);

    // if (this.enddate) {
    //   this.endDate = this.enddate.toLocaleDateString("es-CL");
    //   console.log(this.endDate);
    // }

    this.endDate = this.enddate.toLocaleDateString("es-CL");
    console.log(this.endDate);

    if (this.startdate > this.enddate) {
      console.log('Please select a proper date range. Start date cannot be greater than end date.');
      // this.enddate = this.startdate;
    } else {
      this.searchMolecule1();
    }
  }

  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  clearDates() {
    this.dateCleared = true;
    this.startdate = undefined;
    this.enddate = undefined;
    this.searchMolecule1();
  }

  isPdf(value: any): boolean {
    return typeof value === 'string' && value.includes('.pdf');
  }

  isObject(data: any): boolean {
    return typeof data === 'object' && data !== null;
  }

  getObjectKeys(data: any): string[] {
    return data ? Object.keys(data) : [];
  }

  showEvidenceDialog(item: any): void {
    item.evidence_visible = true;
    if (item.evidence_screenshots && item.evidence_screenshots.length > 0) {
      item.evidence_screenshots_loading = true;
      const payload = {
        image_urls: item.evidence_screenshots
      };
      this.logmanagementservice.getScreenshotsAPI(payload).subscribe((res: any) => {
        if (res && res.images && Array.isArray(res.images)) {
          item.evidence_screenshot_objects = res.images;
        }
        item.evidence_screenshots_loading = false;
      }, (error) => {
        console.error('Error fetching accessible screenshots', error);
        item.evidence_screenshots_loading = false;
      });
    }
  }

  openBase64ImageInNewTab(base64Data: string): void {
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`<body style="margin: 0; display: flex; justify-content: center; align-items: center; background-color: #0e0e0e;"><img src="${base64Data}" style="max-width: 100%; max-height: 100vh; object-fit: contain;" /></body>`);
      newWindow.document.title = "Image Preview";
    }
  }

  private isExcelSources(): boolean {
    return this.selectedSource === 'EX-DB' || this.selectedSource === 'EX-DB-IM';
  }

  private setDefaultDsField() {
    this.dsFieldDropdownOptions = this.fieldOptionsBySectionDS[this.selectedSection] || [{ label: 'ALL', value: 'ALL' }];

    // Prefer ALL if available
    const hasAll = this.dsFieldDropdownOptions.some(x => x.value === 'ALL');
    this.selectedField = hasAll ? 'ALL' : (this.dsFieldDropdownOptions[0]?.value || 'ALL');
  }

  private injectOrangeBookPatentUseCode(options: any[]): any[] {
    if (!options || this.selectedSection !== 'PATENT INFORMATION' || (this.selectedSource !== 'SU' && this.selectedSource !== 'MS')) {
      return options || [];
    }

    const newOptions = [...options];
    const index = newOptions.findIndex(opt => opt.label === 'Orange Book patents');

    if (index !== -1 && !newOptions.some(opt => opt.label === 'Orange Book patents (patent use code)')) {
      newOptions.splice(index + 1, 0, {
        label: 'Orange Book patents (patent use code)',
        value: 'Orange Book patents (patent use code)'
      });
    }
    return newOptions;
  }

}
